import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Czy na pewno?',
    },
    [OrderMethod.Pickup]: 'Czy klient już odebrał zamówienie?',
    [OrderMethod.OnSite]: 'Czy klient już odebrał zamówienie?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Czy zamówienie zostało już dostarczone?',
      [DeliveryProvider.UberDrive]: 'Czy kierowca już odebrał zamówienie?',
      [DeliveryProvider.FirstDelivery]: 'Czy kierowca już odebrał zamówienie?',
      [DeliveryProvider.WoltDrive]: 'Czy kierowca już odebrał zamówienie?',
    },
  },
  buttons: {
    cancel: 'Nie, Anuluj',
    confirm: 'Tak',
  },
};
